import Microgame from '../engine/Microgame.js';

export default class MathGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Calcul !`, en: `Math!`, es: `¡Cálculo!` },
            controls: { fr: `Appuie sur la bonne réponse (ou tape-la)`, en: `Tap the correct answer`, es: `Toca la respuesta correcta` },
            objective: { fr: `Résous l'équation avant la fin`, en: `Solve the equation before time is up`, es: `Resuelve la ecuación antes de que acabe el tiempo` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" stroke-width="2"><path d="M8 8h8M12 4v8M16 16h-4M16 20h-4M8 16l4 4M12 16l-4 4"/></svg>`,
            actions: [
                { type: 'wait', duration: 420 },
                { type: 'tapTarget', selector: '[data-correct="true"]', duration: 180 },
                { type: 'wait', duration: 380 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.correctAnswer = 0;
    }

    setup() {
        this.engine.ui.instruction.textContent = "SOLVE!";

        // Generate Equation
        const a = Math.floor(Math.random() * 9) + 1;
        const b = Math.floor(Math.random() * 9) + 1;
        this.correctAnswer = a + b;

        // Display Equation
        const eq = document.createElement('div');
        eq.textContent = `${a} + ${b} = ?`;
        eq.style.fontSize = '4rem';
        eq.style.fontWeight = 'bold';
        eq.style.color = this.primaryColor;
        eq.style.textShadow = `0 0 20px ${this.primaryColor}`;
        eq.style.position = 'absolute';
        eq.style.top = '30%';
        eq.style.left = '50%';
        eq.style.transform = 'translate(-50%, -50%)';
        this.container.appendChild(eq);

        // Generate Options
        const wrongAnswer = this.correctAnswer + (Math.random() > 0.5 ? 1 : -1) * (Math.floor(Math.random() * 3) + 1);
        const options = [this.correctAnswer, wrongAnswer];

        // Shuffle
        options.sort(() => Math.random() - 0.5);

        // Buttons Container
        const btnContainer = document.createElement('div');
        btnContainer.style.display = 'flex';
        btnContainer.style.gap = '40px';
        btnContainer.style.position = 'absolute';
        btnContainer.style.bottom = '20%';
        btnContainer.style.left = '50%';
        btnContainer.style.transform = 'translate(-50%, 0)';
        this.container.appendChild(btnContainer);

        options.forEach(opt => {
            const btn = document.createElement('div');
            btn.textContent = opt;
            btn.style.fontSize = '3rem';
            btn.style.fontWeight = 'bold';
            btn.style.color = '#000';
            btn.style.background = this.secondaryColor;
            btn.style.padding = '20px 40px';
            btn.style.borderRadius = '10px';
            btn.style.boxShadow = `0 0 20px ${this.secondaryColor}`;
            btn.style.cursor = 'pointer';
            btn.dataset.correct = opt === this.correctAnswer ? 'true' : 'false';

            btn.addEventListener('pointerdown', () => {
                if (!this.active) return;
                if (opt === this.correctAnswer) {
                    this.win();
                } else {
                    this.lose();
                }
            });

            btnContainer.appendChild(btn);
        });
    }
}
